export default __webpack_public_path__ + "static/media/room-1.84d3abc8.jpg";